import { render, staticRenderFns } from "./departmentView.vue?vue&type=template&id=a3b589ec&scoped=true"
import script from "./departmentView.vue?vue&type=script&lang=js"
export * from "./departmentView.vue?vue&type=script&lang=js"
import style0 from "./departmentView.vue?vue&type=style&index=0&id=a3b589ec&prod&lang=scss&scoped=true"
import style1 from "./departmentView.vue?vue&type=style&index=1&id=a3b589ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b589ec",
  null
  
)

export default component.exports